import { APITemplateAttributes, NewTemplate } from '@ardoq/api-types';
import { createEntity, deleteEntity, updateEntity } from './api';

export const templateApi = {
  create: createEntity<NewTemplate & { blankTemplate: boolean }>('template'),
  update: updateEntity<APITemplateAttributes>('template'),
  delete: deleteEntity('template'),
};
